import { Status } from "./Status";


export class ReturnLineItemStatusSmartEnum {
    static Returning = new Status("Returning", 1, "pill--yellow");
    static Submitted = new Status("Processed", 2, "pill--blue");

    public static getName() {
        // Cannot use this.name as it will be the minified value in production
        return "ReturnLineItemStatusSmartEnum";
    }
}
